export default "__VITE_ASSET__cbefda15__"